export const getTariffOptions = (dicts: { tariffIcId: string; tariffIcName: string }[]) =>
  dicts.map(({ tariffIcName: label, tariffIcId: value }) => ({
    label,
    value,
  }));
